import {Injectable} from '@angular/core';
import {AlertController, AlertOptions} from '@ionic/angular/standalone';
import appUtil from '../../util/app.util';

@Injectable({
  providedIn: 'root',
})
export class AlertService {
  constructor(private readonly alertController: AlertController) {}

  async show(options: AlertOptions, iconName?: string): Promise<void> {
    const alert = await this.alertController.create(options);
    // if (!appUtil.isEmpty(iconName) && !appUtil.isEmpty(alert)) {
    //   const iconElement = document.createElement('ion-icon');
    //   iconElement.setAttribute('name', iconName);
    //   alert
    //     .querySelector('.alert-wrapper')
    //     ?.insertBefore(iconElement, alert.querySelector('.alert-title'));
    // }
    console.log(iconName);
    await alert.present();
  }

  async close(): Promise<void> {
    await this.alertController.dismiss();
  }
}
